const REVEAL_CLASS = 'page-reveal';
const VISIBLE_CLASS = 'page-reveal--visible';
const CLEANUP_DELAY = 1100;

/**
 * Sections stop being transformed after their reveal, so sticky
 * and fixed descendants behave normally for the rest of the visit.
 * @param {Element} section - The revealed section.
 */
function finishReveal(section) {
  setTimeout(() => section.classList.remove(REVEAL_CLASS, VISIBLE_CLASS), CLEANUP_DELAY);
}

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      observer.unobserve(entry.target);
      entry.target.classList.add(VISIBLE_CLASS);
      finishReveal(entry.target);
    }
  },
  { rootMargin: '0px 0px -10% 0px' }
);

// Only sections below the fold are hidden, so nothing visible ever flashes
for (const section of document.querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group')) {
  if (section.getBoundingClientRect().top < window.innerHeight) continue;

  section.classList.add(REVEAL_CLASS);
  observer.observe(section);
}
